﻿<script>
	import { getContext, setContext } from 'svelte';

	import ValidationErrorDisplay from "./ValidationErrorDisplay.svelte";
	import ErrorDisplay from "./ErrorDisplay.svelte";

	const { open, close } = getContext("simple-modal");

	const displayError = (errorReponse) => {
		let errorDisplay = null;
		let errorMessage = "";

		if (errorReponse.validationError) {
			console.log("Just An Error:", errorReponse.message);
			errorDisplay = ValidationErrorDisplay;
			errorMessage = errorReponse.message;
		} else {
			console.log("Just An Error:", errorReponse);
			errorDisplay = ErrorDisplay;
			errorMessage = errorReponse;
		}

		open(
			errorDisplay,
			{
				modalKey: 'simple-modal',
				errorMessage: errorMessage,
			},
			{
				closeButton: true,
				closeOnEsc: true,
				closeOnOuterClick: true,
			}
		);
	}

    setContext("error-modal", { displayError });

</script>

<slot></slot>
